import { useEffect, useState } from "react";

/* Debounces a fast-changing value (e.g. a keystroke) so a dependent effect
   only fires once typing pauses. Used for keystroke-triggered API calls —
   see CreateBookingTab's employee-history lookup — where firing on every
   keystroke would be needless load on a 3-worker server. */
export default function useDebouncedValue(value, delayMs = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
